import type { ICcIdStockSummaryResponse } from '../../types/dtos';

export type IccidClusterCard = {
  total: number;
  disponivel: number;
  percentual: number;
};

export type IccidClusterSummary = {
  SC: IccidClusterCard;
  SP: IccidClusterCard;
  RJMG: IccidClusterCard;
};

const emptyCard = (): IccidClusterCard => ({ total: 0, disponivel: 0, percentual: 0 });

const percentualFrom = (disponivel: number, total: number): number =>
  total > 0 ? Math.round((disponivel / total) * 10000) / 100 : 0;

/**
 * Cards regionais da Gestão de ICCIDs.
 * E.R.2 ← `rjmgFastBreakdown`; SH legado ← `shSpLeftoverBreakdown` (não o SP de `porEstado`).
 */
export function buildIccidClusterSummary(
  stockSummary: ICcIdStockSummaryResponse | null | undefined
): IccidClusterSummary {
  if (!stockSummary?.porEstado) {
    return { SC: emptyCard(), SP: emptyCard(), RJMG: emptyCard() };
  }

  const clusters: IccidClusterSummary = {
    SC: emptyCard(),
    SP: emptyCard(),
    RJMG: emptyCard(),
  };

  stockSummary.porEstado.forEach(estado => {
    const est = estado.estado.toUpperCase();
    if (est === 'SC') {
      clusters.SC.total += estado.total;
      clusters.SC.disponivel += estado.disponivel;
    } else if (est === 'SP') {
      clusters.SP.total += estado.total;
      clusters.SP.disponivel += estado.disponivel;
    }
  });

  const shSp = stockSummary.shSpLeftoverBreakdown;
  if (shSp) {
    clusters.SP.total = shSp.total;
    clusters.SP.disponivel = shSp.disponivel;
    clusters.SP.percentual = shSp.percentualDisponivel;
  }

  const rjmg = stockSummary.rjmgFastBreakdown;
  if (rjmg) {
    clusters.RJMG.total = rjmg.total;
    clusters.RJMG.disponivel = rjmg.disponivel;
    clusters.RJMG.percentual = rjmg.percentualDisponivel;
  } else {
    stockSummary.porEstado.forEach(estado => {
      const est = estado.estado.toUpperCase();
      if (est === 'RJ' || est === 'MG' || est === 'ES') {
        clusters.RJMG.total += estado.total;
        clusters.RJMG.disponivel += estado.disponivel;
      }
    });
    clusters.RJMG.percentual = percentualFrom(clusters.RJMG.disponivel, clusters.RJMG.total);
  }

  clusters.SC.percentual = percentualFrom(clusters.SC.disponivel, clusters.SC.total);
  if (!shSp) {
    clusters.SP.percentual = percentualFrom(clusters.SP.disponivel, clusters.SP.total);
  }

  return clusters;
}
